import { Divider } from 'antd';
import React, { FC, useState } from 'react';
import { PartnerCompany } from 'api/partner/types';
import { NewPartnerDrawer } from '../new-partner';
import { HeaderWrapper, InfoBlockWrapper } from './component';
import { PartnerInformation } from './information';
import { PartnerHeader } from './partner-header';

interface Props {
  partner: PartnerCompany;
}
export const PartnerDetail: FC<Props> = ({ partner }) => {
  const [showEditDrawer, setEditDrawerVisibility] = useState(false);

  return (
    <>
      <HeaderWrapper>
        <PartnerHeader
          partner={partner}
          onEdit={() => setEditDrawerVisibility(true)}
        />
      </HeaderWrapper>
      <Divider style={{ margin: 0 }} />
      <InfoBlockWrapper>
        <PartnerInformation partner={partner} />
      </InfoBlockWrapper>
      <NewPartnerDrawer
        visible={showEditDrawer}
        onClose={() => setEditDrawerVisibility(false)}
        partner={partner}
      />
    </>
  );
};
